export enum STATS_TEXT {
  TOTAL_ALLOWANCE = "Total Allowance",
  GROUPS_CREATED = "Groups Created",
  MSISDNS_CREATED = "MSISDNs Created",
  ACCOUNTS_CREATED = "Accounts Created",
  TOTAL_JOBS = "Total Jobs",
  RUNNING_JOBS = "Running Jobs",
  FAILED_JOBS = "Failed Jobs",
  MESSAGES_SUBMITTED = "Messages Submitted",
  MESSAGES_SCHEDULED = "Messages Scheduled",
  MESSAGES_ACCEPTED = "Messages Accepted",
  MESSAGES_DELIVERED = "Messages Delivered",
  MESSAGES_SENT = "Messages Sent",
  SAMPLE_TEXT = "Sample Text",
  GROUPS_PROVISIONING = "Groups Provisioning",
  MSISDNS_PROVISIONING = "MSISDNs Provisioning",
  ACCOUNTS_PROVISIONING = "Accounts Provisioning",
}

export enum STATS_NAMES {
  GROUP_ACCESS = "group-access",
  MSISDN_ACCESS = "msisdn-access",
  USER_ACCOUNTS = "user-accounts",
  QUEUE_MANAGER = "queue-manager",
  QUEUE_MANAGER_DETAILS = "queue-manager-details",
}

export enum STATS_URL {
  USER_ACCOUNT = "/api/account-management/user-accounts/stats",
  MSISDN_ACCESS = "/api/msisdns/stats",
  GROUP_ACCESS = "/api/smart-groups/organisation/stats",
}
